import React from "react";
import { Col, Row } from "antd";
import "./Portal.scss";

const PregFrecOrg = () => {

  return (
    <div className="sectionMenu">
      <p className="tituloOrg">
        Preguntas frecuentes sobre la solicitud de organización
      </p>
      <Row justify="space-around">
        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24} style={{marginRight:'10px'}}>
            <div className="numero">1</div>
            <p>
              <b>¿Cuáles son los requisitos para dar de alta a una organización?</b>
            </p>
            <ul>
              <li>Nombre de la organización y siglas.</li>
              <li>Nombre(s) de la o el Representante Legal.</li>
              <li>Domicilio de la organización.</li>
              <li>Teléfono para efectos de notificación.</li>
              <li>Correo electrónico para efectos de notificación.</li>
              <li><strong>Documentos soporte </strong>(se deberá integrar en un solo archivo en pdf que no exceda a los 6MB).</li>
              <li>Copia de la Credencial para Votar de la o el Representante Legal.</li>
              <li>Copia del Acta Constitutiva.</li>
            </ul>
        </Col>
        <Col xxl={11} xl={11} lg={11} md={24} sm={24} xs={24} style={{marginLeft:'10px'}}>
            <div className="numero">2</div>
            <p>
              <b>Como organización política ¿Puedo realizar el registro de integrantes para participar en la Observación Electoral? </b>
            </p>
            <p>
              No, las agrupaciones políticas no podrán registrarse como agrupación de observadores, no obstante, sus integrantes podrán registrarse de manera individual en su carácter de ciudadanos, garantizando sus derechos políticos-electorales.
            </p>
        </Col>
      </Row>
      <Row justify="space-around">
        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24} style={{marginRight:'10px'}}>
            <div className="numero">3</div>
            <p>
              <b>¿Las organizaciones de observadores y observadoras electorales pueden impartir cursos de capacitación a sus integrantes? </b>
            </p>
            <p>
            Si, para ello deberán notificarlo por escrito al Presidente del Consejo Local o Distrital del INE según corresponda, o en su caso al OPL, con al menos <strong>siete días </strong>de anticipación a la impartición del curso.
            </p>
        </Col>
        <Col xxl={11} xl={11} lg={11} md={24} sm={24} xs={24} style={{marginLeft:'10px'}}>
            <div className="numero">4</div>
            <p>
              <b>¿Puedo registrar en una solicitud a varios integrantes de la organización?</b>
            </p>
            <p>
            No, el registro deberá realizarse de manera individual. Para lo cual, una vez que la organización cumpla con los requisitos para darse de alta en el catálogo de organizaciones, se le proporcionará un código para pronta identificación de la organización, el cual se capturará en la solicitud por cada uno de los integrantes que desee acreditarse como Observador Electoral.
            </p>
        </Col>
      </Row>
    </div>
  );
};

export default PregFrecOrg;